var map = {
	"./site-logo-desktop-footer.svg": 54189,
	"./site-logo-desktop.svg": 7675,
	"./site-logo-drawer-mobile.svg": 10613,
	"./site-logo-drawer.svg": 16342,
	"./site-logo-mobile.svg": 11615,
	"./site-logo-sm.svg": 81989,
	"./site-logo-tv.svg": 27523,
	"./site-logo-wrapper-mobile-scrolled.svg": 62514,
	"./site-logo-wrapper-mobile.svg": 22205,
	"./site-logo-wrapper-scrolled.svg": 47615,
	"./site-logo-wrapper.svg": 50942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19992;